import useBenchService from '../useBenchService';
import { DESC, Filters, FiltersLayout, List, ListPageLayout } from 'framework/list';
import BenchListLayout from './BenchListLayout';
import { EmployeePositionFilter, EmployeeFilter } from 'domain/shared/employee';
import { ProjectFilter } from 'domain/shared/project';

const BenchList = () => {
  const { getBenchListDataMethod } = useBenchService();

  const filters = (
    <Filters>
      <FiltersLayout>
        <EmployeeFilter source="specification:individualAssignmentsByEmployeeAlias" label="Worker" />
        <EmployeePositionFilter source="specification:assignmentsByPositionIds" label="Position" />
        <ProjectFilter source="project.id" label="Project" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <List
      key="employees-dashboard"
      getDataMethod={getBenchListDataMethod}
      defaultSortOrder={DESC}
      defaultSortField="createdAt"
      pageSize={100}
    >
      <ListPageLayout filter={filters} sxPaper={{ p: '10px !important' }}>
        <BenchListLayout />
      </ListPageLayout>
    </List>
  );
};

export default BenchList;
